import React from 'react';

interface IconProps {
  type: string | any;
  className?: string;
}
export const Icon = ({ type, className }: IconProps) => {
  return <>{React.createElement(type, { className: className })}</>;
};
